'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _createClass = function () {
  function a(a, b) {
    for (var c, d = 0; d < b.length; d++) {
      c = b[d], c.enumerable = c.enumerable || !1, c.configurable = !0, 'value' in c && (c.writable = !0), Object.defineProperty(a, c.key, c);
    }
  }

  return function (b, c, d) {
    return c && a(b.prototype, c), d && a(b, d), b;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function _classCallCheck(a, b) {
  if (!(a instanceof b)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(a, b) {
  if (!a) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return b && ('object' == typeof b || 'function' == typeof b) ? b : a;
}

function _inherits(a, b) {
  if ('function' != typeof b && null !== b) throw new TypeError('Super expression must either be null or a function, not ' + typeof b);
  a.prototype = Object.create(b && b.prototype, {
    constructor: {
      value: a,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), b && (Object.setPrototypeOf ? Object.setPrototypeOf(a, b) : a.__proto__ = b);
}

var Minesweeper = function (a) {
  function b(a) {
    _classCallCheck(this, b);

    var c = _possibleConstructorReturn(this, (b.__proto__ || Object.getPrototypeOf(b)).call(this, a));

    return c.generateBoard = function () {
      var a = c.props,
          b = a.width,
          d = a.height,
          e = Array.from({
        length: d
      }, function () {
        return Array.from({
          length: b
        }, function () {
          return c.generateField();
        });
      });
      return e.forEach(function (a, b) {
        a.forEach(function (d, f) {
          if (!d.isBomb) {
            var g = 0;
            c.loopFieldsAround(e, f, b, function (a) {
              a && a.isBomb && g++;
            }), a[f].bombsAround = g;
          }
        });
      }), e;
    }, c.getField = function (a, b, c) {
      try {
        return a[b][c];
      } catch (a) {}
    }, c.generateField = function () {
      return {
        isFlagged: !1,
        isRevealed: !1,
        bombsAround: 0,
        isBomb: Math.random() > 1 - c.props.bombChance
      };
    }, c.loopFieldsAround = function (a, b, d, e) {
      for (var f = d - 1; f <= d + 1; f++) {
        for (var g = b - 1; g <= b + 1; g++) {
          e(c.getField(a, f, g), g, f);
        }
      }
    }, c.leftClickField = function (a, b) {
      return function () {
        var d = c.state,
            e = d.board,
            f = d.isLost,
            g = d.isWon,
            h = c.props,
            i = h.onLose,
            j = h.onWin;

        if (!(f || g)) {
          var k = e[a][b],
              l = [{
            x: b,
            y: a
          }],
              m = function m(a, b) {
            var d = {
              top: {
                x: a,
                y: b - 1
              },
              right: {
                x: a + 1,
                y: b
              },
              bottom: {
                x: a,
                y: b + 1
              },
              left: {
                x: a - 1,
                y: b
              }
            },
                f = function f(a) {
              var b = d[a],
                  f = c.getField(e, b.y, b.x),
                  g = l.find(function (a) {
                return a.x === b.x && a.y === b.y;
              });
              !f || f.isBomb || g || (l.push(b), 0 === f.bombsAround && m(b.x, b.y));
            };

            for (var a in d) {
              f(a);
            }
          };

          if (0 === k.bombsAround) m(b, a);else if (k.isRevealed) {
            var n = 0,
                o = [];
            c.loopFieldsAround(e, b, a, function (a, b, c) {
              a && (a.isFlagged ? n++ : o.push({
                x: b,
                y: c
              }));
            }), k.bombsAround === n && (l = l.concat(o));
          }
          c.setState(function (a) {
            var b = a.board,
                c = !1,
                d = !1;

            if (l.forEach(function (a) {
              var d = b[a.y][a.x];
              d.isRevealed = !0, d.isBomb && (c = !0);
            }), !c) {
              var e = 0;
              b.forEach(function (a) {
                a.forEach(function (a) {
                  a.isRevealed || a.isBomb || e++;
                });
              }), d = 0 == e;
            }

            return c && i ? i() : d && j && j(), {
              board: b,
              isLost: c,
              isWon: d
            };
          });
        }
      };
    }, c.state = {
      board: c.generateBoard(),
      isLost: !1,
      isWon: !1
    }, c;
  }

  return _inherits(b, a), _createClass(b, [{
    key: 'rightClickField',
    value: function d(a, b) {
      var c = this;
      return function (d) {
        d.preventDefault();
        var e = c.state,
            f = e.isLost,
            g = e.isWon;
        f || g || c.setState(function (c) {
          var d = c.board,
              e = d[a][b];
          return e.isFlagged = !e.isFlagged, {
            board: d
          };
        });
      };
    }
  }, {
    key: 'render',
    value: function g() {
      var a = this,
          b = this.state,
          c = b.board,
          d = b.isLost,
          e = b.isWon,
          f = 'minesweeper';
      return f += d ? ' minesweeper_lost' : e ? ' minesweeper_won' : ' minesweeper_active', _react2.default.createElement('table', {
        className: f
      }, _react2.default.createElement('tbody', {
        className: 'minesweeper__body'
      }, c.map(function (b, c) {
        return _react2.default.createElement('tr', {
          key: c,
          className: 'minesweeper__row'
        }, b.map(function (b, e) {
          var f = 'minesweeper__field minesweeper__field_' + b.bombsAround;
          return b.isRevealed || d || (f += ' minesweeper__field_cloud'), b.isFlagged && !d && (f += ' minesweeper__field_flag'), b.isBomb && (f += ' minesweeper__field_bomb'), _react2.default.createElement('td', {
            onClick: a.leftClickField(c, e),
            onContextMenu: a.rightClickField(c, e),
            key: e,
            className: f
          }, b.bombsAround || '');
        }));
      })));
    }
  }]), b;
}(_react2.default.Component);

Minesweeper.propTypes = {
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  onWin: _propTypes2.default.func,
  onLose: _propTypes2.default.func,
  bombChance: function e(a, b, c) {
    var d = a[b];
    if (0 > d || 1 < d) return new Error('Invalid prop "' + b + '" with value of ' + d + ' supplied to "' + c + '". The bomb chance must be a number between 0 and 1.');
  }
}, Minesweeper.defaultProps = {
  width: 10,
  height: 10,
  bombChance: .15
}, exports.default = Minesweeper;